import axios, { AxiosError } from 'axios';

import { Credentials } from '../types/credentials.type';
import { ServiceResponse } from '../types/service-response.type';

import { handleResponseError } from './service';

const AUTH_BASE_URL = process.env.REACT_APP_AUTH_URL;
const USERS_BASE_URL = process.env.REACT_APP_USERS_API;

const logIn = async (credentials: Credentials): Promise<ServiceResponse> => {
    try {
        const response = await axios.post(
            `${AUTH_BASE_URL}/operators`,
            credentials
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

const getMyProfile = async (token: string): Promise<ServiceResponse> => {
    console.log('Auth Service: get my profile');
    try {
        const response = await axios.get(`${USERS_BASE_URL}/operators/me`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

export const authSdk = {
    logIn,
    getMyProfile,
};
